import React, {ReactNode} from 'react';
import {InputAdornment, TextField} from "@mui/material";

type FormFieldTextProps = {
    label?: string;
    placeholder?: string;
    value?: string | number;
    type?: string;
    required?: boolean;
    disabled?: boolean;
    errorText?: string;
    onChange?: (value: string) => void;
    startAdornment?: ReactNode;
    endAdornment?: ReactNode;
    maxRows?: number;
    onKeyDown?: (value: string) => void;
    autoFocus?: boolean;
    onBlur?: () => void;
};

const FormFieldText: React.FC<FormFieldTextProps> = (props) => {
    return (
        <TextField
            label={props.label}
            placeholder={props.placeholder}
            required={props.required}
            disabled={props.disabled}
            error={props.errorText !== undefined && props.errorText !== ''}
            helperText={props.errorText}
            autoFocus={props.autoFocus}
            fullWidth
            onBlur={(e) => {
                if (props.onBlur) {
                    props.onBlur()
                }

            }}
            variant="standard"
            margin="normal"
            // https://mui.com/material-ui/react-text-field/
            // The input label "shrink" state isn't always correct.
            // The input label is supposed to shrink as soon as the input is displaying something.
            // In some circumstances, we can't determine the "shrink" state (number input, datetime input, Stripe input). You might notice an overlap.
            InputLabelProps={{
                shrink: true,
            }}
            onKeyDown={(e) => props.onKeyDown && props.onKeyDown(e.key)}
            value={props.value}
            type={props.type || 'text'}
            multiline={!!(props.maxRows && props.maxRows > 1)}
            maxRows={props.maxRows}
            onChange={(e) => props.onChange && props.onChange(e.target.value)}
            InputProps={{
                // startAdornment: (<InputAdornment position="start">{props.startAdornment}</InputAdornment>),
                endAdornment: <InputAdornment position="end">{props.endAdornment}</InputAdornment>,
            }}
        />
    );
};
export default FormFieldText;